import React from 'react';
import Share from './Share';


class RightMenuDetailsEksport extends React.Component {
    render() {
        return (
            <div className={'right-menu-details-container'} style={this.props.style}>
                <Share/>
            </div>
        )
    }
}

export default RightMenuDetailsEksport


// WEBPACK FOOTER //
// ./src/RightMenuDetailsEksport.js